<template>
    <div v-if="resizeFlag"
         ref="rcGauge"
         class="rc-gauge"></div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'rcGauge',
    props: ['value', 'rgHeight', 'name', 'hideName'],
    data () {
        return {
            myChart: null,
            resizeFlag: true
        }
    },
    mounted () {
        this.init()
    },
    watch: {
        value (val) {
            this.init()
        },
        rgHeight (val) {
            this.resizeFlag = false
            this.$nextTick(() => {
                this.resizeFlag = true
                this.$nextTick(() => {
                    this.init()
                })
            })
        }
    },
    methods: {
        init () {
            this.myChart = echarts.init(this.$refs.rcGauge)
            const option = {
                tooltip: {
                    formatter: this.value === -1 ? this.$i18n.t('暂无数据') : '{b} : {c}%'
                },
                toolbox: {
                    show: false, // 去掉下载和更新
                    feature: {
                        restore: {},
                        saveAsImage: {}
                    }
                },
                series: [
                    {
                        type: 'gauge',
                        radius: '81%', // 仪表大小
                        axisLine: {
                            show: false,
                            lineStyle: { // 属性lineStyle控制线条样式
                                color: [
                                    [1, new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                        offset: 1,
                                        color: '#f5f6f7'
                                    }], false)]

                                ],
                                width: 5
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        },
                        pointer: { // 指针样式
                            show: false
                        },
                        detail: {
                            show: false
                        }
                    },
                    {
                        name: '业务指标',
                        type: 'gauge',
                        axisLine: { // 坐标轴线
                            lineStyle: { // 属性lineStyle控制线条样式
                                color: this.value !== -1 ? [[0.2, '#02a2dc'], [0.8, '#73c946'], [0.9, '#f3ab4d'], [1, '#ea5e3e']] : [[0.1, '#ccc'], [1, '#ccc']],
                                width: 0
                            }

                        },
                        axisLabel: { // 坐标轴小标记
                            distance: 20, // 文字离表盘的距离
                            textStyle: { // 属性lineStyle控制线条样式
                                color: '#fff'
                            }
                        },
                        axisTick: { // 刻度线样式（及短线样式）
                            length: 12, // 属性length控制线长
                            width: 3,
                            lineStyle: { // 属性lineStyle控制线条样式
                                color: 'auto',
                                width: 3
                            }
                        },
                        splitLine: { // 分隔线
                            length: 12, // 属性length控制线长
                            width: 3,
                            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
                                width: 10,
                                color: '#fff'
                            }
                        },
                        pointer: {// 指针样式
                            show: true,
                            // 分隔线
                            length: '50%',
                            width: '3px',
                            shadowColor: '#fff', // 默认透明
                            shadowBlur: 0
                        },
                        title: {
                            show: !this.hideName,
                            offsetCenter: ['0', '120%'],
                            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                // fontWeight: 'bolder',
                                fontSize: 12,
                                color: '#333'
                            }
                        },
                        detail: {
                            offsetCenter: ['0', '60%'],
                            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                // fontWeight: 'bolder',
                                fontSize: 12,
                                color: '#333'
                            },
                            formatter: '\n\n\n{value}%'
                        },
                        data: [{ value: this.value === -1 ? 0 : this.value, name: this.name }]
                    }
                ]
            }
            this.myChart.setOption(option)
        },
        resize () {
            this.myChart.setOption({})
        }
    }
}
</script>

<style lang="less" scoped>
.rc-gauge {
    width: 100%;
    height: 100%;
}
</style>
